<app-ibase-crud-content [deleteRenforced]="true" [showHelpButton]="false"></app-ibase-crud-content>

<!-- BUGFIX: p-message disapear on modal close, making DOM dialog dynamic fix it -->
@if (helpVisible) {
    <p-dialog
        header="Help"
        [modal]="true"
        [(visible)]="helpVisible"
        [resizable]="true"
        [maximizable]="true"
        appendTo="body"
    >
        <p>TODO</p>

        <div class="p-dialog-footer">
            <p-button
                severity="secondary"
                icon="pi pi-times"
                type="button"
                label="Close"
                (click)="helpVisible = false"
            />
        </div>
    </p-dialog>
}
